import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { router } from "./routes.jsx";
import "./styles/globals.css";

/**
 * QueryClient defaults are tuned for an admin panel:
 *  - retry: 1 — admin endpoints surface errors directly; one retry covers a
 *    transient flake without burying the real failure
 *  - refetchOnWindowFocus: false — admin lists shouldn't refetch on every tab
 *    change; staleTime per query controls freshness
 *  - staleTime: 30s — most CRUD pages are happy with 30-second freshness
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: 0,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#13131A",
            border: "1px solid #27272F",
            color: "#F5F5F7",
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>
);
